var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailinline = function SvgEmailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.25A2.741 2.741 0 0 1 2.75.5h16.5A2.77 2.77 0 0 1 22 3.25v11A2.742 2.742 0 0 1 19.25 17H2.75A2.715 2.715 0 0 1 0 14.25v-11Zm2.063 0v.988l7.39 6.059c.902.73 2.149.73 3.05 0l7.434-6.059V3.25c0-.344-.343-.688-.687-.688H2.75a.707.707 0 0 0-.688.688Zm0 3.652v7.348c0 .387.3.688.687.688h16.5c.344 0 .688-.301.688-.688V6.902l-6.102 4.985a4.474 4.474 0 0 1-5.715 0L2.062 6.902Z",
    fill: "#1D2951"
  })));
};
export default SvgEmailinline;